import React from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import complete from '../../images/booth/check.png'

const Wrapper = styled.div`
  font-weight: 600;
  color: #3A2D86;
  letter-spacing: 1px;
  .screen-title {
    text-align: center;
    font-size: 20px;
    margin: 0 auto;
  }
  .message-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16px 0;
    img {
      width: 12%;
    }
    p {
      font-size: 24px;
    }
  }
`

export default function FinishScreen() {

  return (
    <Wrapper>
      <Modal.Header>
        <p className="screen-title">Thank You For Completing The Questionnaire!</p>
      </Modal.Header>
      <div className="message-container">
        <img src={complete} alt="complete tick"/>
        <div>
          <p>You score 9 out of 10!</p>
        </div>
      </div>
    </Wrapper>
  )

}
